import { useEffect, RefObject } from "react";
import $ from "jquery";

export function useOutside(
  ref: RefObject<HTMLElement>,
  handleEvent: () => void,
  preventTarget?: string
): void {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent): void {
      const clickedOutsideRef =
        ref.current && !ref.current.contains(event.target as Node);
      const clickedInsidePreventTarget =
        preventTarget &&
        ($(preventTarget).is(event.target as Element) ||
          $(preventTarget).has(event.target as Element).length > 0);

      if (clickedOutsideRef && !clickedInsidePreventTarget) {
        handleEvent();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}
